import { SvgIcon, type SvgIconProps } from "@mui/material";

interface ImxRewardsMUIProps extends SvgIconProps {
  variant?: "regular" | "bold";
}

/**
 * @deprecated Use ImxRewards instead
 */
export function ImxRewardsMUI({
  variant = "regular",
  ...props
}: ImxRewardsMUIProps) {
  const path =
    variant === "bold"
      ? "M10.1599 4L7.53988 9.25H2.37988L4.99988 4H10.1599ZM12.16 4H11.84L9.20996 9.25H14.79L12.16 4ZM16.4598 9.25H21.6198L18.9998 4H13.8398L16.4598 9.25ZM12.75 10.75H21.38L12.75 21.1V10.75ZM11.2499 21.1V10.75H2.61987L11.2499 21.1Z"
      : "M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z";

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        color: "white",
        fontSize: "24px",
        ...props.sx,
      }}
    >
      <path d={path} fillRule={variant === "bold" ? "evenodd" : undefined} />
    </SvgIcon>
  );
}
